import { createEnv } from "@t3-oss/env-core";
import * as z from "zod";

export const serverEnv = createEnv({
  server: {
    DEV_MODE: z.stringbool().default(false),
    SST_STAGE: z.string().optional(),
    POLAR_ACCESS_TOKEN: z.string().min(1),
    POLAR_WEBHOOK_SECRET: z.string().min(1),
    POLAR_PREMIUM_MONTHLY_PRODUCT_ID: z.string().min(1),
    POLAR_EARLY_BIRD_DISCOUNT_ID: z.string().min(1),
    DISCORD_BOT_TOKEN: z.string().min(1),
    DISCORD_PUBLIC_KEY: z.string().min(1),
    DISCORD_APPLICATION_ID: z.string().min(1),
    DISCORD_GUILD_ID: z.string().min(1),
    DISCORD_MEMBER_ROLE_ID: z.string().min(1),
    DISCORD_PREMIUM_ROLE_ID: z.string().min(1),
    APP_ORIGIN: z.url().optional(),
    POSTHOG_HOST: z.url().default("https://eu.i.posthog.com"),
    POSTHOG_API_KEY: z.string().min(1),
    POLAR_SUCCESS_URL: z.string().default("/premium?checkout=success"),
  },
  runtimeEnv: process.env,
  emptyStringAsUndefined: true,
});

export const clientEnv = createEnv({
  client: {
    VITE_POSTHOG_PROJECT_TOKEN: z.string().min(1),
    VITE_POSTHOG_HOST: z.url().default("https://eu.i.posthog.com"),
  },
  runtimeEnv: import.meta.env,
  clientPrefix: "VITE_",
  emptyStringAsUndefined: true,
});
